<template>
  <div>
    <el-button size="mini" plain type="info" @click="go('/order/list2')">应收费用</el-button>
    <el-button size="mini" plain type="info" @click="go('/order/notpaylist')">已收费用</el-button>
  </div>
</template>

<script>
export default {
  name: "OrderListHeader",
  data(){
    return {
      activeName:''
    }
  },
  mounted(){
    this.activeName=this.$route.path
  },
  methods:{
    go(url){
      if(url!==this.activeName){
        this.$router.push({path:url})
      }
    }
  }

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/OrderListHeader.vue